// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetMapItemsAsyncRequestModel from '../../model/get-map-items-async-request-model';
import LookupAllProfessionsRequestModel from '../../model/lookup-all-professions-request-model';
import LookupAllCategoriesRequestModel from '../../model/lookup-all-categories-request-model';
import GetProfessionByIdRequestModel from '../../model/get-profession-by-id-request-model';
import Tdg_MapItemListResultModel from '../../model/tdg-map-item-list-result-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';
import Tdg_ProfessionModel from '../../model/tdg-profession-model';

export default (service: Servicelayer) => ({
  /**  */
  async getMapItemsAsync(request: GetMapItemsAsyncRequestModel, config?: RequestConfig) {
    const requestDTO = GetMapItemsAsyncRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-map-items-async'] ?? 'tdg/widget/professions';
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        categoryId: requestDTO.categoryId,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_MapItemListResultModel.toModel(dto));
  },
  /**  */
  async lookupAllProfessions(request: LookupAllProfessionsRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-all-professions'] ?? 'tdg/widget/professions/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
  /**  */
  async lookupAllCategories(request: LookupAllCategoriesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-all-categories'] ?? 'tdg/widget/profession-categories/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
  /**  */
  async getProfessionById(request: GetProfessionByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetProfessionByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-profession-by-id'] ?? 'tdg/widget/professions/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_ProfessionModel.toModel(dto));
  },
});
